import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function cashFlowStatement(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@cashFlowStatement/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@cashFlowStatement/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@cashFlowStatement/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}